import PropTypes from 'prop-types';
// @mui
import AddCircle from '@mui/icons-material/AddCircle';
import { useTheme, styled, Box, Button } from '@mui/material';
import { useAppSelector } from 'hooks/redux.hooks';
import { selectTranslations } from 'state/reducers/translation.reducers';

interface Props {
	children?: PropTypes.ReactElementLike | PropTypes.ReactElementLike[];
	onClick?: any;
	size: number;
	inline?: boolean;
}

type exrtaProps = {
	height?: string;
	autoheight?: string;
	autowidth?: string;
};

export const FormButton = styled(Box)<exrtaProps>((props) => ({
	'& .MuiButton-outlined': {
		borderRadius: '8px',
		fontSize: '15px',
		textTransform: 'unset !important',
		minWidth: props?.autowidth ? 'auto!important' : '',
		height: props?.autoheight ? 'auto!important' : '48px',
		fontWeight: 'normal',
		border: '1px solid ' + props.theme.palette.root.darkGrayed,
		'&.whithBg': {
			backgroundColor: props.theme.palette.root.basicWhite + '!important',
		},
	},
	'& .MuiButtonBase-root': {
		borderRadius: '8px',
		height: '48px',
		fontSize: '15px',
		textTransform: 'unset !important',
		//minWidth: '156px',
		fontWeight: 'normal',
		padding: '5px 32px',

		'&.MuiButton-contained:hover': {
			backgroundColor: props.theme.palette.root.basicDeepGreen,
		},
		'&.MuiButton-contained:focus': {
			backgroundColor: props.theme.palette.root.basicDeepGreen,
		},
	},
	'& .singleFormButton': {
		width: '70%',
		margin: '0 15%',
		[props.theme.breakpoints.down('sm')]: {
			width: '100%',
			margin: 0,
		},
	},
}));

export const SelectBoxButton = styled(Box)((props) => ({
	'& .MuiButtonBase-root': {
		height: '32px',
		fontSize: '14px',
		[props.theme.breakpoints.down('sm')]: {
			fontSize: '13px',
		},
		fontWeight: 'normal',
		border: '1px solid #cbdcde',
		boxShadow: 'none',
		borderRadius: '16px',
		color: 'inherit',
		whiteSpace: 'nowrap',
		'&.MuiButton-contained': {
			backgroundColor: props.theme.palette.root.basicWhite,
			'&.selectedItems': {
				backgroundColor: props.theme.palette.root.brandPrimary_008,
				borderColor: props.theme.palette.root.brandSecondary + '!important',
			},
		},
		'&.MuiButton-contained:hover': {
			backgroundColor: props.theme.palette.root.basicWhite,
			borderColor: props.theme.palette.root.brandSecondary + '!important',
			boxShadow: 'none',
		},
		'&.MuiButton-contained:focus': {
			backgroundColor: props.theme.palette.root.basicWhite,
			'&.selectedItems': {
				backgroundColor: props.theme.palette.root.brandPrimary_008,
				borderColor: props.theme.palette.root.brandSecondary + '!important',
			},
		},
	},
}));

export const MultiSelectBoxButton = styled(Box)((props) => ({
	// transform: translate(-9px, -9px) scale(0.75);
	// background: #fff;
	// padding: 0 3px;

	'& .MuiButtonBase-root': {
		height: '54px',
		fontSize: '14px',
		[props.theme.breakpoints.down('sm')]: {
			fontSize: '13px',
		},
		fontWeight: 'normal',
		border: '1px solid #c4c4c4',
		boxShadow: 'none',
		borderRadius: '4px',
		color: 'inherit',
		whiteSpace: 'nowrap',
		'&.MuiButton-contained': {
			backgroundColor: props.theme.palette.root.basicWhite,
			'&.selectedItems': {
				backgroundColor: props.theme.palette.root.brandPrimary_008,
				borderColor: props.theme.palette.root.brandSecondary + '!important',
			},
		},
		'&.MuiButton-contained:hover': {
			backgroundColor: props.theme.palette.root.basicWhite,
			borderColor: props.theme.palette.root.brandSecondary + '!important',
			boxShadow: 'none',
		},
		'&.MuiButton-contained:focus': {
			backgroundColor: props.theme.palette.root.basicWhite,
			'&.selectedItems': {
				backgroundColor: props.theme.palette.root.brandPrimary_008,
				borderColor: props.theme.palette.root.brandSecondary + '!important',
			},
		},
	},
}));

export const GoBackLink = styled(Box)((props) => ({
	'&.MuiBox-root': {
		width: '24px',
		height: '24px',
		borderRadius: '4px',
		backgroundColor: props.theme.palette.root.brandPrimary_008,
		justifyContent: 'center',
		display: 'flex',
		alignItems: 'center',
		cursor: 'pointer',
	},
}));
